module.exports = __webpack_public_path__ + "img/09_ic_chime_black_62px.46aa6463.svg";